interface Window {
  newrelic: { addPageAction: Function };
}

export function getWindow() {
  // @ts-ignore returning window object
  return window as Window;
}
